module.exports = __webpack_public_path__ + "img/style_2_pl.d5b05547.jpeg";